import { useTranslation } from 'react-i18next';
import { Search } from 'lucide-react';

import { FieldClearButton } from '../FieldClearButton';
import { Input } from '../Input';

type RegistrationsHeaderProps = {
  searchQuery: string;
  onSearchChange: (query: string) => void;
};

export const RegistrationsHeader = (props: RegistrationsHeaderProps) => {
  const { searchQuery, onSearchChange } = props;
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap items-center justify-between gap-2">
      <p className="text-sm font-medium">{t('Registrations')}</p>
      <div className="w-full sm:w-72">
        <Input
          value={searchQuery}
          placeholder={t('Search by name or surname')}
          icon={<Search />}
          endAdornment={
            !!searchQuery && (
              <FieldClearButton onClear={() => onSearchChange('')} />
            )
          }
          onChange={(event) => onSearchChange(event.target.value)}
        />
      </div>
    </div>
  );
};
